/*@ngInject*/
const PermissionsEditorHeaderController = function ($scope, $rootScope, $element, $state, $uibModal, coreConstant, localization, configurationConstant, modalUtil, configurationMediator, permissionAction, permissionsModel, configurationActionsUtil, coreMediator, databaseDownloadSectionName) {

    $element.addClass('permissionsEditorHeader');

    this.translations = null;
    this.actions = null;
    this.context = {
        identifier: 'permissionsEditorHeader',
        actions: {},
        fallthrough: null,
        model: {
            contextType: coreConstant.CONTEXT_NONE
        }
    };
    this.context.actions[coreConstant.CONTEXT_NONE] = '';
    this.actionSubTexts = {};
    this.permissionsUpdated = false;
    this.actionsTimeLastModified = '';

    this.$onInit = function () {
        localization.getTranslationByKey('permissionsEditorHeader').then((translations) => {
            this.translations = translations;
            this.userTypeName = _.get(this.translations, `userTypeName.${this.userType}`);
            this.actions = [];
            this.loadActions();
        });
    };

    this.loadActions = function () {
        configurationMediator.loadPermissionActions(this.userType).then((actions) => {
            this.actions = [];
            this.actions.push({
                actions: actions.actions,
                contextType: this.context.model.contextType
            });
            const hasManagePermission = actions.actions.length > 0;
            this.hasManagePermission({hasPermission: hasManagePermission});
            this.actionsTimeLastModified = new Date().getTime();
            this.processActions(this.actions);
        });
    };

    this.processActions = function (actions) {
        this.actions = actions;
        this.actionSubTexts = {};

        _.each(this.actions, (subAction) => {
            _.each(subAction.actions, (action) => {
                if (action.name === permissionAction.SAVE || action.name === permissionAction.DISCARD) {
                    action.enabled = this.permissionsUpdated;
                }

                if (action.name === permissionAction.SAVE && this.permissionsUpdated) {
                    this.actionSubTexts[action.name] = {
                        class: 'unsavedChanges',
                        text: _.get(this.translations, 'unsavedChanges')
                    };
                }
            });
        });

        this.actionsTimeLastModified = new Date().getTime();
    };

    $scope.$on(configurationConstant.event.PERMISSIONS_UPDATED, () => {
        this.permissionsUpdated = true;
        this.processActions(this.actions);
    });

    this.handleAction = function (action) {
        if (action.enabled) {
            switch (action.name) {
                case permissionAction.BACKUP:
                    configurationActionsUtil.backup(databaseDownloadSectionName.ASSIGNED_AUTHORIZATIONS, _.get(this.translations, 'backup.name'), _.get(this.translations, 'backup.loadingBar'), _.get(this.translations, 'backup.successMessage'));
                    break;
                case permissionAction.SAVE:
                    configurationActionsUtil.updatePermissions(permissionsModel.getPermissions()).then(() => {
                        this.permissionsUpdated = false;
                        this.loadActions();
                        coreMediator.refreshUserDetails();
                    });
                    break;
                case permissionAction.DISCARD:
                    modalUtil.showConfirmationModal(null, null, null, 'permissionsEditorHeader.discardConfirmation', null, true, () => {
                        $rootScope.$broadcast(coreConstant.event.SHOW_FADING_NOTIFICATION, _.get(this.translations, 'discardConfirmation.success'));
                        this.permissionsUpdated = false;
                        return $state.reload();
                    });
                    break;
                default:
                    modalUtil.showActionNotImplementedModal(action.name);
                    break;
            }
        }
    };

    $scope.$on('$stateChangeStart', (event, toState, toParams, fromState) => {
        const isCurrentStatePermissionManager = _.startsWith(fromState.name, 'configuration.permissionsEditor'),
            isTargetSameAsCurrent = toState.name === fromState.name;

        if (toState.name === 'login') {
            return;
        }

        if (this.permissionsUpdated && isCurrentStatePermissionManager && !isTargetSameAsCurrent && permissionsModel.getPermissions()) {
            event.preventDefault();
            configurationActionsUtil.updatePermissions(permissionsModel.getPermissions()).then(() => {
                this.permissionsUpdated = false;
                this.loadActions();
                $state.go(toState, toParams);
            });
        } else {
            if (isCurrentStatePermissionManager && isTargetSameAsCurrent && this.permissionsUpdated) {
                configurationActionsUtil.updatePermissions(permissionsModel.getPermissions()).then(() => {
                    $state.reload();
                });
            }
        }
    });
};

angular.module('ums.configuration')
    .controller('permissionsEditorHeaderController', PermissionsEditorHeaderController);
